export const AD_COUNTDOWN = 'ASAdCountdown';
export const CAPTIONS_BUTTON = 'ASCaptionsButton';
export const CLOSE_BUTTON = 'CloseButton';
export const CURRENT_TIME_DISPLAY = 'currentTimeDisplay';
export const FULLSCREEN_TOGGLE = 'ASFullscreenToggle';
export const MUTE_TOGGLE = 'ASMuteToggle';
export const MUTED_OVERLAY_BUTTON = 'ASMutedOverlayButton';
export const PLAY_TOGGLE = 'ASPlayToggle';
export const PROGRESS_CONTROL = 'progressControl';
export const SHARE_CONTROL = 'ASShareControl';
export const SHARE_OVERLAY = 'ASShareOverlay';
export const AD_CLICK_OVERLAY = 'ASAdClickOverlay';
export const SUBTITLES_BUTTON = 'ASSubtitlesButton';
export const VOLUME_CONTROL = 'volumeControl';
export const VOLUME_PANEL = 'volumePanel';
export const WATCH_BUTTON = 'ASWatchButton';



// WEBPACK FOOTER //
// ./src/ui/UIControlsNames.js